<script setup lang="ts">
/**
 * TimeSignatureIcon – eigenes Inline-SVG für die Taktart-Aktion.
 *
 * Zeigt zwei gestapelte Ziffern (Zähler über Nenner, „4/4"-Form) – die klassische Notations-
 * Darstellung einer Taktart (klarer als eine Uhr, die eher Tempo assoziiert). Bewusst minimal,
 * damit es auf den ~14 px großen Toolbar-Buttons lesbar bleibt.
 *
 * Single-Root-`<svg>` mit `width/height=1em` (matcht die `fa6-solid:*`-Nachbarn) und `currentColor`,
 * damit es die Button-Textfarbe UND `disabled:opacity-30` erbt. `class` fällt automatisch durch.
 */
</script>

<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
  >
    <text x="12" y="11" text-anchor="middle" font-size="13" font-weight="700" font-family="serif">4</text>
    <text x="12" y="23" text-anchor="middle" font-size="13" font-weight="700" font-family="serif">4</text>
  </svg>
</template>
